<template>
  <div v-if="visible">
    <Navbar :type="$type"/>

    <div class="container">
      <div class="box">
        <div class="columns is-centered" v-if="showTags">
          <div class="column is-half">
            <b-field label="Tags">
              <b-taginput
                :value="data.tags"
                @input="setTags"
                :data="tagsAutofill"
                autocomplete
              ></b-taginput>
            </b-field>
          </div>
        </div>

        <div class="field is-grouped is-grouped-right">
          <div class="control">
            <b-switch v-model="useCustomerAddress">
              Use Customer Address
            </b-switch>
          </div>
        </div>

        <form-wizard
          :data.sync="data"
          :fields="fields"
          :metadata="$metadata"
          @submit="onSubmit"
          hide-boxes
        ></form-wizard>
      </div>
    </div>

    <div class="modal is-active" v-if="showPoint">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box is-clipped">
          <h1 class="title" v-if="point">Confirm Point</h1>
          <h1 class="title" v-else>Find Point for this Location</h1>
          <p class="subtitle" v-if="!point">
            We could not find coordinates for this Address.
          </p>

          <gmap-map
            class="gmap"
            :center="center"
            :zoom="3"
            @click="point = $event.latLng; center = $event.latLng"
          >
            <gmap-marker
              v-if="point"
              :position="point"
            ></gmap-marker>
          </gmap-map>

          <div class="buttons is-right">
            <button class="button is-primary" @click="onCreate">Create Location</button>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close" @click="showPoint = false"></button>
    </div>
  </div>
</template>

<script>
import Library from '@/library'
import Navbar from '@/components/ViewComponents/Navbar.vue'

export default {
  name: 'CreatePickupLocation',

  props: {
    customerId: {
      required: true
    }
  },

  data () {
    return {
      visible: true,
      center: {
        lat: 0,
        lng: 0
      },
      point: null,
      showPoint: false,
      useCustomerAddress: false,
      data: {}
    }
  },

  methods: {
    async onSubmit (data) {
      const loader = this.$loading.open()
      try {
        const state = await this.$entity.get('State', this.data.stateId)

        const point = await Library.Functions.geocode(
          `${this.data.street}, ${this.data.city}, ${state.data.name} ${this.data.postalCode}`
        )

        console.log(point)

        if (point && point.geometry && point.geometry.location) {
          const coords = {
            lat: point.geometry.location.lat(),
            lng: point.geometry.location.lng()
          }

          this.point = coords
          this.center = coords
        }

        this.showPoint = true
      } catch (e) {
        console.error(e)
      } finally {
        loader.close()
      }
    },

    setTags (e) {
      this.$set(this.data, 'tags', e)
    },

    async onCreate () {
      if (this.point) {
        const loader = this.$loading.open()
        try {
          const response = await this.$entity.create('PickupLocation', {
            ...this.data,
            primaryContactId: this.customerId,
            relationType: 'Manager',
            point: this.point
          })

          if (response && response.data) {
            this.$router.push({ name: 'View Pickup Location', params: { id: response.data.id }})
          }
        } catch (e) {
          console.error(e)
          this.$handleError('There was an error creating your Pickup Location', e.response.data)
        } finally {
          loader.close()
        }
      } else {
        this.$dialog.confirm({
          message: 'Do you want to create this Pickup Location without a point?',
          onConfirm: async () => {
            const loader = this.$loading.open()
            try {
              const response = await this.$entity.create('PickupLocation', {
                primaryContactId: this.customerId,
                relationType: 'Manager',
                ...this.data
              })

              if (response && response.data) {
                this.$router.push({ name: 'View Pickup Location', params: { id: response.data.id }})
              }
            } catch (e) {
              console.error(e)
              this.$handleError('There was an error creating your Pickup Location', e.response.data)
            } finally {
              loader.close()
            }
          }
        })
      }
    }
  },

  computed: {
    fields () {
      return Library.Entities.getCreateFields(this.$type)
    },

    showTags () {
      if (this.$metadata && this.$metadata.properties && this.$metadata.properties.find(prop => prop.propertyName === 'tags')) {
        return true
      } else {
        return false
      }
    },

    tagsAutofill () {
      if (this.showTags) {
        const autofill = this.$metadata.properties.find(prop => prop.propertyName === 'tags');

        return autofill.options.possibleValues || []
      }
    }
  },

  watch: {
    async useCustomerAddress (value) {
      if (value) {
        const loader = this.$loading.open()

        try {
          const response = await this.$entity.get(Library.Enums.ObjectType.Customer, this.customerId)
          const customer = response.data

          this.data.street = customer.street
          this.data.city = customer.city
          this.data.countyId = customer.countyId
          this.data.stateId = customer.stateId
          this.data.postalCode = customer.postalCode
        } catch (e) {
          this.$handleError('There was an error getting the address of the Customer', e.response.data)
        } finally {
          loader.close()
        }
      } else {
        this.data.street = ''
        this.data.city = ''
        this.data.countyId = null
        this.data.stateId = null
        this.data.postalCode = ''
      }

      this.visible = false
      this.$nextTick(() => {
        this.visible = true
      })
    }
  },

  components: {
    FormWizard: Library.Components.FormWizard,
    Navbar
  }
}
</script>

<style lang="scss" scoped>
  .gmap {
    height: 50vh;
    margin-bottom: 1rem;
  }
</style>
